<template>
  <div
    class="settled-bets-expansion-header-wrapper"
  >
    <div class="settled-bets-expansion-header"
         v-bind:class="[{'settled-bets-expansion-header--lost' : market.pnl < 0,
                'settled-bets-expansion-header--even' : market.pnl === 0,
                'settled-bets-expansion-header--won' : market.pnl >= 0}]">
      <span v-if="market.tournamentName">{{market.tournamentName}} &ndash; {{$t(`sports.${market.sportIdentifier}`)}}</span>
    </div>
    <div class="settled-bets-expansion-header-inner">
      <div class="settled-bets-date-wrapper">
        <div class="settled-bets-date-container">
          <span class="settled-bets-date" v-if="market.eventType ==='Virtual'"><span class="settled-bets-date-title">{{$t(`trader.settledMarkets.ended`)}}</span>{{getFormattedDate(market.eventEnd)}}</span>
          <span class="settled-bets-date" v-if="market.eventType !=='Virtual'"><span class="settled-bets-date-title">{{$t(`trader.settledMarkets.started`)}}</span>{{getFormattedDate(market.eventStart)}}</span>
        </div>
      </div>
      <div class="settled-bets-result-wrapper">
        <div class="settled-bets-result-container">
              <span class="settled-bets-result-team">
                  <span v-if="market.awayTeam">{{market.homeTeam | capitalise}} &ndash; {{market.awayTeam | capitalise}}</span>
                  <span v-if="!market.awayTeam && market.eventName">{{market.eventName | capitalise}}</span>
              </span>

        </div>
      </div>
      <div class="settled-bets-winnings-wrapper">
        <div class="settled-bets-winnings-cell"
             v-bind:class="[{'settled-bet-panel-status-bar--lost' : market.pnl < 0,
                      'settled-bet-panel-status-bar--even' : market.pnl === 0,
                      'settled-bet-panel-status-bar--won' : market.pnl > 0}]">
          <span>{{$t(`trader.settledMarkets.netWinnings`) | removeDiacriticsFromUppercase}}</span>
          <div class="settled-bets-winnings-value">
            <span>{{market.pnl| numberWithCommasAndCurrency(userCurrency)}}</span>
          </div>
        </div>
        <div class="settled-bets-commission-cell">
          <span>{{$t(`trader.settledMarkets.commissions`) | removeDiacriticsFromUppercase}}</span>
          <div class="settled-bets-commission-value">
            <span>{{market.commission| numberWithCommasAndCurrency(userCurrency)}}</span>
          </div>
        </div>
        <div class="settled-bets-more-cell">
          <v-icon @click.self="toggleMoreOptions" v-show="!isDownloading">krypt-more-vertical</v-icon>
          <v-icon v-show="isDownloading" class="kryptium-loader">krypt-loader</v-icon>
          <div class="more-options-absolute" v-click-outside="closeMoreOptions"
               v-bind:class="{'more-options-absolute--open':shouldShowMoreOptions}">
            <div class="more-options-content">
              <div class="more-options" @click="getBetsReport({eventId:market.eventId})">
                <span>{{$t(`trader.settledMarkets.exportOptions.betsReportEvent`)}}</span>
              </div>
              <div class="more-options" @click="getMarketsReport({eventId:market.eventId})">
                <span>{{$t(`trader.settledMarkets.exportOptions.marketsReportEvent`)}}</span>
              </div>
              <div class="more-options" @click="getBetsReport({tournamentId:market.tournamentId})">
                <span>{{$t(`trader.settledMarkets.exportOptions.betsReportCompetition`)}}</span>
              </div>
              <div class="more-options" @click="getMarketsReport({tournamentId:market.tournamentId})">
                <span>{{$t(`trader.settledMarkets.exportOptions.marketsReportCompetition`)}}</span>
              </div>
              <div class="more-options" @click="getBetsReport({sportId:market.sportId})">
                <span>{{$t(`trader.settledMarkets.exportOptions.betsReportSport`)}}</span>
              </div>
              <div class="more-options" @click="getMarketsReport({sportId:market.sportId})">
                <span>{{$t(`trader.settledMarkets.exportOptions.marketsReportSport`)}}</span>
              </div>
              <div class="more-options" @click="getBetsReport({})">
                <span>{{$t(`trader.settledMarkets.exportOptions.betsReportAllSports`)}}</span>
              </div>
              <div class="more-options" @click="getMarketsReport({})">
                <span>{{$t(`trader.settledMarkets.exportOptions.marketsReportAllSports`)}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue';

export default {
  name: 'settledMarketCard',
  props: [
    'betData',
    'market'
  ],
  data: function () {
    return {
      shouldShowInfo: false,
      shouldShowMoreOptions: false,
      _clickOutside: null
    };
  },
  computed: {
    isDownloading:function(){
      return this.$store.state.trader.settledMarkets.isDownloading;
    },
    userCurrency: function () {
      return this.$store.state.userCurrency;
    },
    /*    betId:function () {
          return this.betData.id;
        }*/
  },
  watch: {
    betId: function () {
      this.shouldShowInfo = false;
    }
  },
  methods: {
    getMarketsReport: function (payload) {
      this.$store.commit('setIsDownloadingReport',true);
      this.closeMoreOptions();
      this.$store.dispatch('getMarketsReport', payload);
    },
    getBetsReport: function (payload) {
      this.$store.commit('setIsDownloadingReport',true);
      this.closeMoreOptions();
      this.$store.dispatch('getBetsReport', payload);

    },
    getFormattedDate: function (date) {
      return new Intl.DateTimeFormat(window.SelectedTimeLocalisation,
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          // hour12:false,
          hourCycle: 'h23',
          minute: 'numeric'
        }
      ).format(new Date(date));
    },
    copyTextToClipboard: function (text) {
      let textArea = document.createElement('textarea');

      // Place in the top-left corner of screen regardless of scroll position.
      textArea.style.position = 'fixed';
      textArea.style.top = 0;
      textArea.style.left = 0;

      // Ensure it has a small width and height. Setting to 1px / 1em
      // doesn't work as this gives a negative w/h on some browsers.
      textArea.style.width = '2em';
      textArea.style.height = '2em';

      // We don't need padding, reducing the size if it does flash render.
      textArea.style.padding = 0;

      // Clean up any borders.
      textArea.style.border = 'none';
      textArea.style.outline = 'none';
      textArea.style.boxShadow = 'none';

      // Avoid flash of the white box if rendered for any reason.
      textArea.style.background = 'transparent';

      textArea.value = text;

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        console.log('Copying text command was ' + msg);
      } catch (err) {
        console.log('Oops, unable to copy');
      }

      document.body.removeChild(textArea);
    },

    showInfo: function () {
      this.shouldShowInfo = !this.shouldShowInfo;
    },
    toggleMoreOptions: function () {
      this.shouldShowMoreOptions = !this.shouldShowMoreOptions;
    },
    closeMoreOptions: function () {
      this.shouldShowMoreOptions = false;
    }
  },
  directives: {
    clickOutside: {
      componentUpdated: function (el, binding, vnode) {
        setTimeout(() => {
          const handler = (e) => {
            if (!el.contains(e.target) && el !== e.target && vnode.context.$data.shouldShowMoreOptions) {
              binding.value(e);
            }
          };
          if (vnode.context.$data.shouldShowMoreOptions) {
            vnode.context.$data._clickOutside = handler;
            document.addEventListener('click', vnode.context.$data._clickOutside);
          } else {
            document.removeEventListener('click', vnode.context.$data._clickOutside);
            vnode.context.$data._clickOutside = null;
          }
        }, 100);
      },
      unbind: function (el, binding, vnode) {
        document.removeEventListener('click', vnode.context.$data._clickOutside);
        vnode.context.$data._clickOutside = null;
      }
    }
  }
};
</script>

<style scoped>
  .kryptium-loader{
    animation: spin 1s infinite linear;
    font-size: 16px!important;
    padding: 4px;
    /* line-height: 19px; */
    cursor: default;
  }
  .kryptium-loader:before {
    color: var(--grey-400)!important;
  }
  .settled-bet-panel-status-bar--won {
    color: var(--aquaman);
  }

  .settled-bet-panel-status-bar--lost {
    color: var(--cyborg);
  }

  .settled-bet-panel-status-bar--even {
    color: var(--grey-600);
  }

  .settled-bets-container {
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
  }

  #bets-container {
    overscroll-behavior: contain;
  }

  .settled-bets-controls {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    padding: 8px 0;
    border-bottom: 1px solid var(--grey-200);
  }

  .settled-bets-controls-title {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0 8px;
  }

  .settled-bets-controls-title > span {
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    color: #5C5F61;
  }

  .settled-bets-dropdown-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 8px;
    flex-direction: column;
    width: 100%;
  }

  .settled-bets-dropdown {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--grey-300);
    border-radius: 4px;
    width: 100%;
    cursor: pointer;
    background-color: var(--grey-100);
  }

  .settled-bets-dropdown-text {
    display: flex;
    padding: 8px;
    user-select: none;
    overflow: hidden;
  }

  .settled-bets-dropdown-text > span {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: var(--grey-800);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .settled-bets-controls-selections {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
  }

  .settled-bets-controls-selection {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
  }

  .search-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    padding-top: 8px;
    padding-right: 8px;
    padding-left: 8px;
  }

  .search-label {
    display: flex;
    align-items: center;
    flex-direction: row;
    width: 100%;
    margin-bottom: 4px;
  }

  .search-label > span {
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    color: var(--grey-500);
  }

  .search-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding-left: 8px;
    padding-right: 4px;
    border: 1px solid var(--grey-300);
    border-radius: 4px;
  }

  .search-wrapper:hover {
    border: 1px solid var(--grey-400);
  }

  .search-wrapper:focus-within {
    border: 1px solid var(--primary);
  }

  .search-input {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 8px 0;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: var(--grey-800);
    caret-color: var(--primary);
    height: 100%;
    max-height: 32px;
  }

  .search-input::placeholder {
    color: var(--grey-400);
  }

  .search-input:-ms-input-placeholder {
    color: var(--grey-400);
  }

  .search-input::-ms-input-placeholder {
    color: var(--grey-400);
  }

  .search-input:focus {
    outline: none;
  }

  .search-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
  }

  .search-icon > .v-icon {
    color: var(--grey-500);
  }

  .selection-radio-btn {
    display: flex;
    align-items: center;
    flex-direction: row;
    width: 100%;
    padding: 0 8px;
  }

  .selection-radio-btn > span {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    margin: 8px 8px 4px 0px;
    color: var(--grey-500);
  }

  .settled-bets-dropdown-selection {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: calc(100% - 32px);
  }

  .settled-bets-dropdown-dropdown-arrow, .settled-bets-dropdown-dropdown-arrow > i {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 16px;
    height: 16px;
  }

  .settled-bets-dropdown-dropdown-arrow {
    margin-right: 4px;
    margin-left: 8px;
  }

  .settled-bets-dropdown-dropdown-arrow > i {
    font-size: 16px;
    color: var(--grey-900);
  }

  .settled-bets-dropdown-dropdown-arrow-open > i {
    transform: rotateZ(-180deg);
  }

  .settled-bets-dropdown-anchor {
    position: relative;
    width: 100%;
  }

  .settled-bets-dropdown-absolute {
    position: absolute;
    width: 100%;
    z-index: 10;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.19);
    top: 0px;
    transition: all 0.3s ease-in-out;
    background: white;
    border-radius: 4px;
    padding: 0;
  }

  .settled-bets-dropdown-absolute-open {
    top: 4px;
    overflow: hidden;
    padding: 4px 0;
  }

  .settled-bets-dropdown-contents::-webkit-scrollbar {
    width: 8px;
    background: #f0f0f0;
    /* disabling to make it look like on Firefox
    border-radius: 4px;
    margin-bottom: 4px; */
  }

  .settled-bets-dropdown-contents::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    /* disabling to make it look like on Firefox
    border-radius: 4px; */
  }

  .settled-bets-dropdown-contents::-webkit-scrollbar-thumb:hover {
    background: #a6a6a6;
    /* disabling to make it look like on Firefox
    border-radius: 4px; */
  }

  .settled-bets-dropdown-contents {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    max-height: 0;
    width: 100%;
    overflow: hidden;
    flex-direction: column;
    transition: max-height 0.4s cubic-bezier(0.25, 0.8, 0.5, 1);
    border-radius: 4px;
    /*border: white 1px solid;*/
    background: white;
    scrollbar-width: thin;
  }


  .settled-bets-dropdown-contents-open {
    overflow-x: hidden !important;
    overflow-y: hidden !important;
    max-height: 200px;
  }

  .settled-bets-dropdown-contents:first-child {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  .settled-bets-dropdown-contents:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .settled-bets-dropdown-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    transition: background-color 0.25s ease-in-out;
  }

  .settled-bets-dropdown-item:hover {
    background: var(--grey-200);
    cursor: pointer;
  }

  .settled-bets-dropdown-item-selection {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .settled-bets-dropdown-item-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    margin: 0 4px;
  }

  .settled-bets-dropdown-item-text {
    display: flex;
    padding: 8px;
    user-select: none;
  }

  .settled-bets-dropdown-item-text > span {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: var(--grey-800);
  }

  .date-pickers {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 4px;
    width: 100%;
  }

  /*  .date-picker{
      position: relative;
    }*/

  .date-picker-input {
    display: inline-table;
    position: absolute;
    transform: scale(0);
    transform-origin: 0% 0%;
    transition: all 0.3s ease-in-out;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.19);
    /* applied same shadow with dropdown lists for consistency
    box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12); */
    margin-top: 4px;
    z-index: 11;
  }

  .date-picker-input--end {
    transform-origin: 100% 0%;
    right: 8px;
  }

  .date-picker-input--open {
    transform: scale(1);
  }

  .date-picker {
    padding: 0 4px;
    overflow: hidden;
    width: 100%;
  }

  .date-picker-label {
    display: flex;
    width: 100%;
    overflow: hidden;
    padding-top: 8px;
    padding-bottom: 4px;
  }

  .date-picker-label > span {
    font-size: 12px;
    line-height: 16px;
    align-items: center;
    color: var(--grey-500);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .date-picker-container {
    cursor: pointer;
  }

  .date-picker-container * {
    pointer-events: none;
  }

  .settled-bets {
    display: flex;
    flex-direction: column;
    padding: 8px;
    height: 100%;
  }

  .settled-bets-expansion-header-wrapper {
    display: flex;
    flex-direction: column;
    padding: 0px !important;
  }

  .settled-bets-expansion-header-inner {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 8px;
    transition: all 0.2s ease-in-out;
    cursor: auto;
  }

  .settled-bets-expansion-header-inner span {
    cursor: text !important;
  }

  .settled-bets-expansion-header-inner * {
    user-select: text;
  }

  .settled-bets-expansion-header {
    display: flex;
    padding: 8px;
    min-height: unset;
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
    width: 100%;
  }

  .settled-bets-expansion-header > span {
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    color: #FFFFFF;
  }

  .settled-bets-expansion-header-wrapper > >>> .v-expansion-panel-header__icon {
    margin-bottom: 0px !important;
    margin-top: 0px !important;
  }

  .settled-bets-expansion-header > >>> .v-expansion-panel-header__icon > .v-icon {
    color: white !important;
    font-size: 24px;
  }

  .settled-bets-expansion-header--won {
    background-color: var(--aquaman);
  }

  .settled-bets-expansion-header--lost {
    background-color: var(--cyborg);
  }

  .settled-bets-expansion-header--even {
    background-color: var(--grey-400);
  }

  .settled-bets-date-wrapper {
    display: flex;
    padding-bottom: 4px;
  }

  .settled-bets-date-container {
    display: flex;
    margin-right: auto;
  }

  .settled-bets-date-title {
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    align-items: center;
    color: var(--grey-500);
    margin-right: 6px
  }

  .settled-bets-date {
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    align-items: center;
    color: var(--grey-900);
  }

  .settled-bets-result-wrapper {
    display: flex;
    padding-bottom: 8px;
  }

  .settled-bets-result-container {
    display: flex;
  }

  .settled-bets-result-title {
    margin-right: 8px;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    align-items: center;
    color: var(--grey-500);
  }

  .settled-bets-result-team {
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    align-items: center;
    color: var(--grey-900);
    margin-right: auto;
  }

  .settled-bets-result {
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    text-align: right;
    color: var(--grey-900);
  }

  .settled-bets-winnings-wrapper {
    display: flex;
    align-items: flex-end;
  }

  .settled-bets-winnings-cell, .settled-bets-commission-cell {
    display: flex;
    flex-direction: column;
    margin-right: 8px;
    min-width: 100px;
  }

  .settled-bets-commission-cell {
    margin-right: auto;
  }

  .settled-bets-more-cell {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 28px; /* calc(100% - 17px); */
    cursor: pointer;
    position: relative;
    margin-left: 8px;
  }

  .settled-bets-more-cell:hover > .v-icon {
    color: var(--grey-600);
  }


  .settled-bets-more-cell > .v-icon {
    font-size: 24px;
    color: var(--grey-400);
  }

  .settled-bets-winnings-cell > span {
    font-weight: bold;
    font-size: 10px;
    line-height: 14px;
    display: flex;
    align-items: center;
    /*color: var(--aquaman);*/
    padding-bottom: 1px;
    text-transform: uppercase;
    max-width: 100px;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .settled-bets-commission-cell > span {
    font-weight: bold;
    font-size: 10px;
    line-height: 14px;
    display: flex;
    align-items: center;
    color: var(--grey-600);
    padding-bottom: 1px;
    text-transform: uppercase;
    max-width: 100px;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .settled-bets-winnings-value, .settled-bets-commission-value {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    background-color: var(--grey-100);
    text-align: center;
    border: 1px solid var(--grey-100);
  }

  .settled-bets-commission-value > span, .settled-bets-winnings-value > span {
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    color: var(--grey-900);
    padding: 5px 4px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .custom-radio-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 16px;
    width: 16px;
    background: var(--grey-100);
    border: 1px solid var(--grey-300);
    border-radius: 50%;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }

  .custom-radio-btn--selected {
    background: var(--primary);
    border-color: var(--superman);
  }

  .custom-radio-btn-inner {
    height: 8px;
    width: 8px;
    background: white;
    opacity: 0.4;
    border-radius: 50%;
  }


  .empty-settled-bets {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
  }

  .empty-settled-bets-image {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 122px;
    max-height: 122px;
  }

  .empty-settled-bets-image > .v-icon {
    display: flex;
    align-items: center;
    max-width: 122px;
    max-height: 122px;
    font-size: 122px;
    color: var(--grey-300);
  }

  .empty-settled-bets-text {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
  }

  .empty-settled-bets-text > span {
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;
    text-align: center;
    color: var(--grey-400);
  }

  .settled-bet-card:first-of-type {
    margin-top: 0px !important;
  }

  .number-of-bets-wrapper {
    display: flex;
    overflow: hidden;
    max-width: calc(100% / 3);
    flex-wrap: nowrap;
    flex-shrink: 0;
    margin-left: 8px;
  }

  .number-of-bets-title {
    display: flex;
    overflow: hidden;
  }

  .number-of-bets {
    padding-right: 4px;
  }

  .number-of-bets-title > span {
    font-size: 12px;
    line-height: 16px;
    color: var(--grey-500);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .number-of-bets > span {
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    color: var(--grey-900);
  }

  .settled-bets-expansion-header-wrapper {
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.19) !important;
    border-radius: 6px;
    margin-bottom: 8px;
  }

  .more-options-absolute {
    position: absolute;
    right: 28px;
    top: 0;
    transform: scale(0, 0);
    transition: all 0.35s ease-in-out;
    transform-origin: 100% 0%;
    width: 250px;
    border-radius: 6px;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.19) !important;
    background-color: white;
    z-index: 5;
    padding: 4px 2px 4px 0;
  }

  .more-options-absolute--open {
    transform: scale(1, 1);
  }

  .more-options-content{
    display: flex;
    flex-direction: column;
    max-height: 200px;
    overflow-y: auto;
    scrollbar-width: thin;
  }

  .more-options-content::-webkit-scrollbar {
    width: 8px;
    background: #f0f0f0;
  }

  .more-options-content::-webkit-scrollbar-thumb {
    background: #c1c1c1;
  }

  .more-options-content::-webkit-scrollbar-thumb:hover {
    background: #a6a6a6;
  }

  .more-options {
    display: flex;
    position: relative;
    padding: 8px;
    cursor: pointer;
  }

  .more-options:hover {
    background-color: var(--grey-200);
  }

  .more-options > span {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: var(--grey-800);
    pointer-events: none;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .settled-bets-more-cell > .theme--light.v-icon:focus::after {
    opacity: 0 !important;
  }

  /*Vuetify*/

  >>> .v-expansion-panel > .settled-bets-expansion-header {
    border-radius: 6px;
  }

  >>> .v-expansion-panel {
    transition: border-radius 1s ease-in-out;
    border-radius: 6px;
    margin-bottom: 8px;
    margin-top: 0px !important;
  }

  >>> .v-expansion-panel:not(:first-child)::after {
    border-top: none !important;
  }

  >>> .v-expansion-panel--active > .settled-bets-expansion-header {
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }

  >>> .v-expansion-panel-header:not(.v-expansion-panel-header--mousedown):focus::before {
    opacity: 0 !important;
  }

  >>> .v-expansion-panel-content__wrap {
    padding: 0px 4px 8px 4px;
  }

  >>> .v-input__slot {
    margin-bottom: 0px !important;
    padding-right: 4px;
    padding-left: 8px;
    border-radius: 4px !important;
    border: solid 1px var(--grey-300);
  }

  .date-picker-container:hover >>> .v-input__slot {
    border: solid 1px var(--grey-400) !important;
  }

  >>> .v-input__slot:before {
    border: none !important;
  }

  >>> .v-text-field__slot > input {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: var(--grey-800) !important;
  }

  >>> .v-input__icon > .v-icon {
    color: var(--grey-500);
  }

  .v-text-field {
    padding: 0px !important;
    margin: 0px !important;
  }

  .v-text-field > >>> .v-input__control > .v-input__slot:after {
    border: none !important;
  }

  .v-text-field >>> .v-input__prepend-inner, .v-text-field >>> .v-input__append-inner {
    margin: 4px 0;
  }

  @keyframes spin {
    0% {
      transform: rotateZ(0)
    }
    100% {
      transform: rotateZ(360deg)
    }
  }
</style>
